var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranging"},_vm._l((_vm.menu),function(item){return _c('div',{key:item.id,class:_vm.idx == item.id?'btn se':'btn',on:{"click":function($event){return _vm.select(item)}}},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }